import { BaseMapper } from '@ps/utils';
import { BillingRuleItemDto, BillingRulesDto } from '../dtos/buyer.dto';
import { BillingRuleItem, BillingRules } from '../../state/buyer-state.model';

export class BillingRulesMapper extends BaseMapper<
  BillingRulesDto,
  BillingRules
> {
  public override fromDto(dto: BillingRulesDto): BillingRules {
    return {
      id: String(dto.id),
      example: dto.example,
      mandatory: dto.mandatory,
      autoGenerate: dto.autoGenerate,
      length: { min: dto.length.min, max: dto.length.max },
      rules: dto.rules.map((rule) => this._mapRuleItem(rule)),
    };
  }

  private _mapRuleItem(dto: BillingRuleItemDto): BillingRuleItem {
    return {
      id: null,
      range: { start: dto.range.start, end: dto.range.end },
      entry: dto.entry,
      definition: dto.definition,
      char: dto.char,
      required: dto.required,
    };
  }
}
